import { fileSize } from "utils/functions";
import Feedback from "ui/Feedback/Feedback";
import "./FileSize.scss"

const FileSize = (props) => {

    const size = parseInt(props.size)

    let feedback = "warning"
    if (size < 102400 && !props?.showDanger) {
        feedback = "success"
    }
    else if (size > 512000 || props?.showDanger) {
        feedback = "danger"
    }
    return (
        <span className="filesize">
            {fileSize(props.size)}
            {
                props.showFeedback ? (
                    <Feedback classNames={"filesize__feedback"} feedback={feedback}/>
                ) : null
            }
        </span>
    )
}

export default FileSize